"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { cn } from "@/lib/utils";

const sectionTabs = [
  { href: "/expenses", label: "Expenses" },
  { href: "/savings", label: "Savings" },
  { href: "/investments", label: "Investments" },
  { href: "/goals", label: "Savings Goals" },
  { href: "/literacy", label: "Financial Literacy" },
  { href: "/tables", label: "Tables" },
];

export function AppSectionTabs() {
  const pathname = usePathname();
  const shouldShowTabs = sectionTabs.some(({ href }) => pathname.startsWith(href));

  if (!shouldShowTabs) return null;

  return (
    <div className="border-b border-white/10 bg-black px-4 py-4 sm:px-6">
      <nav className="flex flex-wrap gap-2" aria-label="Section navigation">
        {sectionTabs.map(({ href, label }) => {
          const isActive = pathname === href || pathname.startsWith(`${href}/`);

          return (
            <Link
              key={href}
              href={href}
              className={cn(
                "rounded-md px-4 py-2 text-sm text-white transition-colors",
                isActive ? "bg-blue-500 hover:bg-blue-600" : "bg-green-700 hover:bg-green-600"
              )}
            >
              {label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
